"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayLegalPersonType = void 0;
var MangopayLegalPersonType;
(function (MangopayLegalPersonType) {
    MangopayLegalPersonType["Business"] = "BUSINESS";
    MangopayLegalPersonType["Soletrader"] = "SOLETRADER";
})(MangopayLegalPersonType || (exports.MangopayLegalPersonType = MangopayLegalPersonType = {}));
//# sourceMappingURL=MangopayLegalPersonType.js.map